import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

function PropertyView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [property, setProperty] = useState(null);

  useEffect(() => {
    axios
      .get(`http://127.0.0.1:8000/api/residential/residential_view/${id}/`)
      .then((response) => setProperty(response.data))
      .catch((error) => console.error("Error fetching property details:", error));
  }, [id]);

  if (!property) {
    return <p className="text-center mt-5">Loading property details...</p>;
  }

  return (
    <div className="container mt-4">
      <button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <div className="card shadow-lg">
        <img
          src={`http://127.0.0.1:8000${property.Image}`}
          alt={property.BhkType}
          className="card-img-top"
          style={{ height: "400px", objectFit: "cover" }}
        />
        <div className="card-body">
          <h3 className="card-title">{property.BhkType}</h3>
          <p className="card-text">
            <strong>District:</strong> {property.District} <br />
            <strong>Town:</strong> {property.Town} <br />
            <strong>Street:</strong> {property.Street} <br />
            <strong>Property Age:</strong> {property.PropertyAge} <br />
            <strong>Parking:</strong> {property.Parking} <br />
            <strong>Terrace:</strong> {property.Terrace} <br />
            <strong>Price:</strong> ₹{property.ExpectedPrice}
          </p>
          <p>
            <strong>Description:</strong> {property.Description}
          </p>
          <p>
            <strong>Contact:</strong> {property.PrimaryNumber}{" "}
            {property.SecondaryNumber && `, ${property.SecondaryNumber}`}
          </p>
        </div>
      </div>
    </div>
  );
}

export default PropertyView;
